import { CarePlanSubmitScreen } from "app/screens/residents/show/CarePlanSubmitScreen";

export default function ResidentAddCarePlanPage() {
  return <CarePlanSubmitScreen />;
}
